<template>
    <div>
        <loading :active.sync="isLoading"
                 :is-full-page="fullPage"
                 color="#00F">
        </loading>
        <vue-snotify></vue-snotify>
        <b-row>
            <b-col cols="12">
                <div class="animated fadeIn">
                    <b-row>
                        <b-col sm="12">

                            <div class="table-responsive-md">

                                <Vuetable
                                        class="table table-striped table-bordered nowrap vue-tbl cards remove-header"
                                        ref="Vuetable"
                                        :api-url="getUrl"
                                        :http-options="httpOptions"
                                        :fields="fields"
                                        pagination-path
                                        @vuetable:pagination-data="onPaginationData"
                                        @vuetable:loaded="loaded"
                                        :append-params="moreParams"
                                        :per-page="perPage"
                                        :row-class="onRowClass">
                                    <template slot="actions" scope="props">
                                        <div class="custom-actions">

                                            <b-button v-if="[2 , 5].indexOf(props.rowData.status) >= 0" class="btn btn-success btn-sm" @click="onActionClicked('edit-item',props.rowData,props.rowIndex)">
                                                <i class="icon-pencil"></i> Edit
                                            </b-button>
                                            <b-button v-if="props.rowData.status == 7"
                                                      class="btn btn-warning btn-sm"
                                                      @click="
                                                      onActionClicked(
                                                        'download-pdf',
                                                        props.rowData,
                                                        props.rowIndex,
                                                        true
                                                      )">
                                                <i class="cui-cloud-download">Download</i>
                                            </b-button>

                                        </div>
                                    </template>
                                </Vuetable>

                                <b-row>
                                    <b-col>
                                        <div class="vuetable-pagination ui basic segment grid row">
                                            <b-col cols="4">
                                                <vuetable-pagination-info
                                                        ref="paginationInfo"
                                                ></vuetable-pagination-info>
                                            </b-col>
                                            <b-col cols="8">
                                                <vuetable-pagination
                                                        style="float:right;"
                                                        ref="pagination"
                                                        @vuetable-pagination:change-page="onChangePage"
                                                ></vuetable-pagination>
                                            </b-col>
                                        </div>
                                    </b-col>
                                </b-row>

                            </div>

                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Vue from "vue";
    import Vuetable from "vuetable-2/src/components/Vuetable";
    import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
    import VuetablePagination from "@/components/vuetable/VuetablePaginationBootstrap4";
    import {mapState, mapActions} from "vuex";
    import {http} from "@/config/http";

    export default {
        name: "Proposaltable",
        components: {
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                uuid:'',
                httpOptions: {
                    headers: {
                        "Content-Type": "application/json;charset=UTF-8",
                        Accept: "application/json",
                        Authorization: "Bearer " + localStorage.getItem("access_token")
                    },
                    data: {

                    }
                },
                moreParams: {
                    uuid:this.uuid
                },
                getUrl: process.env.VUE_APP_API_ENDPOINT + "proposal/list",
                fields: [
                    {
                        name: "proposal_no",
                        title:
                            '<span class="orange glyphicon glyphicon-user"></span> Proposal No',
                        sortField: "proposal_no",
                        callback: "proposal_no_return"
                    },
                    {
                        name: "vehicle_number",
                        title:
                            '<span class="orange glyphicon glyphicon-user"></span> Vehicle No',
                        sortField: "vehicle_number",
                        callback: "vehicle_no_return"
                    },
                    {
                        name: "created_at",
                        title: '<span class="orange glyphicon glyphicon-user"></span> Date',
                        sortField: "created_at",
                        callback: "proposal_created_date_return"
                    },
                    {
                        name: "proposal_status_value",
                        title: '<span class="orange glyphicon glyphicon-user"></span> Status',
                        sortField: "proposal_status_value",
                        callback: "proposal_status_return"
                    },
                    {
                        name: "__slot:actions",
                        title: '<span class="orange glyphicon glyphicon-user"></span> Action',
                        width: '150px'
                    }
                ],
                data: [

                ],
                perPage: 10,
                sortOrder: [],
                filterText: ""
            };
        },
        methods: {
            ...mapActions("proposal", [
                "downloadPdf",
                "getProposalData"
            ]),
            ...mapActions("login", [
                "getGuestToken"
            ]),
            loaded(){
                this.isLoading = false;
            },
            vehicle_no_return(vehicle_no) {
                return "Vehicle No - " + vehicle_no;
            },
            proposal_no_return(proposal_no) {
                return "Proposal No - " + proposal_no;
            },
            proposal_created_date_return(date) {
                return "Proposal Created Date - " + date;
            },
            proposal_status_return(status) {
                return "Status - " + "<div class='badge badge-primary badge-pill'>" + status + "</div>";
            },
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData);
                this.$refs.paginationInfo.setPaginationData(paginationData);
            },
            onChangePage(page) {
                this.$refs.Vuetable.changePage(page);
            },
            onFilterSet(filters) {
                this.moreParams = {
                    insured_name: filters.insured_name,
                    quotation_number: filters.quotation_number,
                    insurance_type: filters.insurance_type,
                    user_account: filters.user_account,
                    date: filters.date,
                    uuid:this.uuid
                };
                Vue.nextTick(() => this.$refs.Vuetable.refresh());
            },
            onFilterReset() {
                this.moreParams = {};
                Vue.nextTick(() => this.$refs.Vuetable.refresh());
            },
            onActionClicked(action, data, rowIndex, pdf = false) {
                const filterData = {
                    proposal_id_inc: data.id
                };
                this.getProposalData(filterData).then((response) => {
                    if (!response.error) {
                        let proposal_status = response.data.data.proposal_status;
                        if (action == "edit-item") {
                            if ([2, 5].indexOf(proposal_status) >= 0) {
                                this.$router.push({
                                    name: 'ProposalEditCustomer', query: {
                                        id: data.hash_id_value,
                                        uuid: this.uuid
                                    }
                                })
                            } else {

                            }
                        }

                        else if (action == "download-pdf") {
                            this.isLoading = true;
                            if([7].indexOf(proposal_status) >= 0) {
                                const params = {
                                    proposal_id: data.id,
                                };
                                this.downloadPdf(params).then((response) => {
                                    this.isLoading = false;
                                    if (!response.error) {
                                        this.$snotify
                                            .success(response.data.message, "", {
                                                position: "centerTop",
                                            })
                                            .on("destroyed", () => {
                                                    this.$refs.Vuetable.refresh();
                                                    window.open(
                                                        process.env.VUE_APP_UPLOAD_PDF_PATH +
                                                        response.data.data,
                                                        "_blank"
                                                    );
                                                }
                                            );
                                    }
                                });
                            }
                            else{
                                this.$snotify
                                    .error("Access Denied", "", {
                                        position: "centerTop",
                                    });
                                Vue.nextTick(() => this.$refs.Vuetable.refresh());
                            }
                        }

                    }
                });
            },
            onRowClass(dataItem , index){
             return '';
            },
        },
        watch: {
            data(newVal, oldVal) {
                this.$refs.Vuetable.refresh();
            }
        },

        mounted() {
            this.isLoading = true;
            this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
            this.$events.$on("filter-reset", e => this.onFilterReset());
            if (this.$route.query.uuid) {
                this.uuid = this.$route.query.uuid;
            }else{
                this.$router.push({
                    name: 'PublicAccessDenied'
                })
            }
        },
        beforeCreate() {
            if (this.$route.query.uuid) {
                this.uuid = this.$route.query.uuid;
            }
        },
        created() {
          /*Logged customer user as guest user*/
          let obj = {};
          obj.uuid = this.$route.query.uuid;
          this.getGuestToken(obj).then((response) => {
            if (!response.error) {
              if (this.access_token === null) {

              } else {

              }
            }
          });
        }
    };
</script>

<style>
    .remove-header thead{
        display: none;
    }

    .card-body >>> table > tbody > tr > td {
        cursor: pointer;
    }

    .custom-actions .btn {
        margin-right: 5px;
        margin-bottom: 3px;
        width: 100%;
    }

    .cards tbody tr {
        float: left;

        border: 1px solid #aaa;
        box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.25);
        background-color: white;
        width: 23%;
        margin: 1%;
    }

    .cards tbody td {
        display: block;
        width: 100%;
        overflow: hidden;
        text-align: left;
        min-height: 58px;
        padding: 12px;
    }

    @media (max-width: 769px) {
        .cards tbody tr {
            float: left;
            border: 1px solid #aaa;
            box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.25);
            background-color: white;
            width: 98%;
            margin: 1%;
        }

        .cards tbody td {
            display: block;
            width: 100%;
            overflow: hidden;
            text-align: left;
            min-height: 58px;
            padding: 12px;
        }
    }


    .cards tbody label {
        display: inline;
        position: relative;
        font-size: 85%;
        font-weight: normal;
        top: -5px;
        left: -3px;
        float: left;
        color: #808080;
    }
</style>
